import { useEffect, useState } from "react";

import { CONSTANTS } from "utils/constants";

const DEFAULT_MAX_LENGTH =
    CONSTANTS.CONTROL_CONSTANTS.MAX_CONTROL_RESULT_COMMENT_CHARS;

interface UseModalCommentProps {
    /** When this flips to `true` the comment is reset (modal re-opened). */
    open: boolean;
    maxLength?: number;
    /** When `true`, a non-empty comment is required for the input to be valid. */
    required?: boolean;
}

export function useModalComment({
    open,
    maxLength = DEFAULT_MAX_LENGTH,
    required = false,
}: UseModalCommentProps) {
    const [comment, setComment] = useState("");

    // Reset the comment each time the modal opens.
    useEffect(() => {
        if (open) {
            // eslint-disable-next-line react-hooks/set-state-in-effect
            setComment("");
        }
    }, [open]);

    const trimmed = comment.trim();
    const isTooLong = comment.length > maxLength;
    const isValid = !isTooLong && (!required || trimmed.length > 0);

    return { comment, setComment, trimmed, isValid, isTooLong };
}
